import React, { useState, useEffect } from 'react';
//, Fragment
import { Alert, Row, Col, Spinner } from 'react-bootstrap';
//import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { clusterApi } from '../../../util/Api';
import ReactApexChart from "react-apexcharts";
import { roundNum } from '../../../util/ChartUtils';

const ExperimentComparison = (props) => {

    const experiments = props?.experiments ? props.experiments : [];
    const accountKey = props?.accountKey ? props.accountKey : '';
    const original = props?.original ? props.original : null;

    const [errors, setErrors] = useState([]);
    //const [models, setModels] = useState([]);
    //const [scores, setScores] = useState([]);
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(true)

    const plotColors = {
        heatmap: {
            colorScale: {
                ranges: [
                    { from: -1, to: 0, color: "#ffffff" },
                    //{ from: -0.05, to: 0.99999999, color: "#fafbfb" },
                    { from: 0, to: 0.05, color: "#ffffff" },
                    { from: 0.05, to: 0.1, color: "#fafbfb" },
                    { from: 0.1, to: 0.18, color: "#f9fbfb" },
                    { from: 0.18, to: 0.21, color: "#f8fbfb" },
                    { from: 0.21, to: 0.24, color: "#f7fbfb" },
                    { from: 0.24, to: 0.27, color: "#f6fafb" },
                    { from: 0.27, to: 0.30, color: "#f4f9fb" },
                    { from: 0.30, to: 0.33, color: "#f2f8fb" },
                    { from: 0.33, to: 0.36, color: "#eff7fb" },
                    { from: 0.36, to: 0.39, color: "#ebf5fb" },
                    { from: 0.39, to: 0.42, color: "#e7f3fb" },
                    { from: 0.42, to: 0.45, color: "#e2f1fb" },
                    { from: 0.45, to: 0.48, color: "#dbeefb" },
                    { from: 0.48, to: 0.51, color: "#d2eafb" },
                    { from: 0.51, to: 0.54, color: "#c7e5fb" },
                    { from: 0.54, to: 0.57, color: "#c1e3fb" },
                    { from: 0.57, to: 0.60, color: "#bbe0fb" },
                    { from: 0.60, to: 0.63, color: "#b4ddfb" },
                    { from: 0.63, to: 0.66, color: "#acdafb" },
                    { from: 0.66, to: 0.69, color: "#a3d6fb" },
                    { from: 0.69, to: 0.72, color: "#99d2fb" },
                    { from: 0.72, to: 0.75, color: "#8ecdfb" },
                    { from: 0.75, to: 0.78, color: "#82c8fb" },
                    { from: 0.78, to: 0.81, color: "#75c2fb" },
                    { from: 0.81, to: 0.84, color: "#66bcfb" },
                    { from: 0.84, to: 0.87, color: "#55b5fb" },
                    { from: 0.87, to: 0.90, color: "#43adfb" },
                    { from: 0.90, to: 0.93, color: "#2fa4fb" },
                    { from: 0.93, to: 0.96, color: "#199afb" },
                    { from: 0.96, to: 0.99, color: "#008ffb" }
                ]
            }
        }
    }

    //send experiments to python processor to get similarities between the responses

    useEffect(() => {
        let models = experiments.map((e) => { return { provider: e.provider, model: e.model } });
        let texts = []
        let series = []
        for (const exp of experiments) {
            if(Array.isArray(exp?.results?.responses) && exp.results.responses.length>0) {
                texts.push(exp.results.responses[0]?.content);
            } else {
                texts.push("")
            }
            
        }
        //add original in 
        if(original !== null && original?.responses?.length > 0 ){
            models.unshift({provider: 'original', model: 'original'})
            if(Array.isArray(original?.responses) && original.responses.length > 0){
                texts.unshift(original?.responses[0]?.response)
            } else {
                texts.unshift("")
            }
            
        }
        //console.log('texts', texts)
        let options = {
            accountKey: accountKey,
            texts: texts
        }
        setLoading(true)
        setSeries([])
        if (texts.length > 1) {
            axios.post(clusterApi + '/compare', options, { withCredentials: true })
                .then((res) => {
                    if (res.data.status === 'ok') {
                        if (res.data.scores !== null) {
                            let tempScores = null
                            if (typeof (res.data.scores) === 'string') {
                                //console.log("this is a string")
                                //tempScores = eval(res.data.scores)
                                //console.log(tempScores)
                                try {
                                    tempScores = JSON.parse(res.data.scores)
                                } catch (jsonErr) {
                                    tempScores = []
                                }
                            }
                            else {
                                tempScores = res.data.scores
                            }
                            //console.log(tempScores)
                            //setScores(tempScores)
                            //setModels(models)
                            let element = {};
                            let data = [];
                            for (let r = 0; r < tempScores.length; r++) {
                                element = {
                                    name: models[r].model,
                                    data: []
                                }
                                data = []
                                for (let c = 0; c < tempScores[r].length; c++) {
                                    data.push({
                                        x: models[c].model,
                                        y: roundNum(tempScores[r][c], 4)
                                    })
                                }
                                element.data = data
                                series.push(element)
                            }
                            //console.log(series)
                            setLoading(false);
                            setSeries(series)
                        }
                    } else {
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                });
        }
        else {
            setLoading(false)
        }


    }, [accountKey, experiments]);


    return (
        <div>
            {
                (errors.length > 0) ? (
                    <Alert variant='danger'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {loading === true ? (

                <Alert variant='primary'>
                    <div className='d-inline-flex'>
                        <div><Spinner animation="border" variant='primary' /></div>
                        <div className='ms-3'>Comparing similarities</div>
                    </div>

                </Alert>

            ) : null}
            {
                (series.length > 1) ? (
                    <>
                        <Row className='mt-3'>
                            <Col>

                                <div className='chart-card'>
                                    <div className='chart-title'>Similarity</div>
                                    <ReactApexChart type="heatmap" height={400}
                                        options={{
                                            /*chart: {
                                                type: 'heatmap',
                                                height: 400
                                            },*/
                                            colors: ["#008ffb"],
                                            yaxis: {
                                                reversed: true
                                            },
                                            xaxis: { position: 'top' },
                                            plotOptions: plotColors,
                                            legend: {
                                                show: false
                                            },
                                            dataLabels: {
                                                style: {
                                                    colors: ['#333333']
                                                }
                                            }
                                        }}
                                        series={series} />
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : null
            }
            {/*
                (scores.length > 0) ? (
                    <>
                        <Row className='mt-3'>
                            <Table>
                                <tbody>
                                    {scores.map((row, r) => (
                                        <tr key={`row.${r}`}>
                                            {row.map((col, c) => (
                                                <td key={`col.${r}.${c}`}>{roundNum(col, 4)}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Row>

                    </>
                ) : (null)
            */}
        </div>
    )
}

export default ExperimentComparison;